<script>
import i18n from "../i18n";
import simplebar from "simplebar-vue";
import OrderModal from "@/components/orderModal"
import { menuItems } from "./horizontal-menu";
import OrdersApi from "@/services/orders-api";
import slidingComponents from "@/components/slidingComponents";
import { mapGetters } from 'vuex';

//import SupplierApi from "@/services/suppliers-api";
// import HorizontalNav from "@/components/horizontal-nav";

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    
    return null;
}
 

/**
 * Nav-bar Component
 */
export default {
  computed: {

    vueAppCustomerInfo() {
      const vueAppCustomerInfo = {
        address: process.env.VUE_APP_CUSTOMER_ADDRESS,
        email: process.env.VUE_APP_CUSTOMER_EMAIL,
        phone: process.env.VUE_APP_CUSTOMER_PHONE,
      };

      return vueAppCustomerInfo;
    },

    isHeaderBarEnable(){
      return process.env.VUE_APP_FEATURE_HEADER_BAR_ENABLE === 'true'
    },
    envSupplierName(){
      return process.env.VUE_APP_CLIENT_NAME
    },
    customerPortalName(){
      return process.env.VUE_APP_CUSTOMER_PORTAL_NAME
    },
    customerAsstesDiractory(){
      return process.env.VUE_APP_CUSTOMER_ASSETS_DIRACTORY
    },

    mobileLogoHeight(){
      return process.env.VUE_APP_MOBILE_LOGO_HEIGHT
    },

    logoHeight(){
      return process.env.VUE_APP_LOGO_HEIGHT
    },
    

    permission() {
      const  storedPermissions = JSON.parse(getCookie('permission')) || [];
      return storedPermissions
    },
    isPartner() {
      const  isPartner = JSON.parse(getCookie('isPartner')) || [];
      return isPartner
    },
    notifPagesNbr() {
      return Math.ceil(this.notificationsCount / this.notifPageSize);
    },

    userShortName() {
      var short = this.$cookies.isKey('userFullName') ? this.$cookies.get('userFullName').split(' ')[0] : '';      
      return short.length > 7 ? short.substring(0, 7) + '...' : short;
    },

    userFullName() {
      return this.$cookies.isKey('userFullName') ? this.$cookies.get('userFullName') : '';      
    },

    companyName() {
      return this.$cookies.isKey('companyName') ? this.$cookies.get('companyName').length > 10 ? this.$cookies.get('companyName').substring(0, 10) + '...' : this.$cookies.get('companyName') : '';   
    },

    fullCompanyName() {
      return this.$cookies.isKey('companyName') ? this.$cookies.get('companyName') : '';   
    },

    isSupplier() {
      return this.$cookies.get('userr') == 1;
    },

    isAdmin() {
      return this.$cookies.get('userr') == 2;
    },

    role() {
      return this.$cookies.get('userr');
    },

    draftOrderId() {
      return this.$cookies.isKey('drafto') ? this.$cookies.get('drafto') : null;
    },

    draftOrderLinesCount() {
      return this.$cookies.isKey('draftoc') ? this.$cookies.get('draftoc') : null;
    },
    
    isClaimShowInTopBar(){
      return  process.env.VUE_APP_FEATURE_CHANGE_CLAIM_TO_TOP_MENU_FOR_CUSTOMER === 'true'
    },
        
    hideUsersMenu(){
      return  process.env.VUE_APP_FEATURE_HIDE_USERS_ON_TOP_MENU_FOR_CUSTOMER === 'true'
    },

    isReportingSupplierEnable(){
      return  process.env.VUE_APP_FEATURE_REPORTING_SUPPLIER === 'true'
    },

    customCatalogLabel(){
      return  process.env.VUE_APP_FEATURE_CUSTOM_CATALOG_LABEL
    },

    showCustomerInfo() {
      return process.env.VUE_APP_FEATURE_CUSTOMER_INFO === 'true';
    },

    showShearchButtonOnTopBar() {
      return process.env.VUE_APP_FEATURE_SHOW_SEARCH_BUTTON_TOP_BAR === 'true';
    },

    filtredNotifications(){
      return this.notifications.filter(n => n.type != 5)
    },

    isAgencySupplier() {
      return this.$cookies.get('iss');
    },

    ...mapGetters('notification', ['notifications', 'notificationsCount']),


  },
  data() {
    return {
      languages: [
        {
          language: "fr",
          title: "French",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,

      keyword:"",
      supplierFullName:'',

      interval: null,

      notifPage: 1,
      notifPageSize: 3,

      displayMobileSearch: false,
      selectedUserList:[],
      showUsersModal:false,

      showDraftOrder: false,

      menuItems: menuItems,

      blockOrdersStatus: {},

      isCustomerBlocked: false,
      customerinfoStatus: null,

    };
  },
  components: { simplebar/*, HorizontalNav*/, OrderModal,slidingComponents },
  created() {
    this.$store.dispatch('notification/startPeriodicNotificationsFetch', {page: this.notifPage,pageSize: this.notifPageSize});
  },
  beforeDestroy () {
    clearInterval(this.interval);
  },

  
  mounted() {
    

    this.$root.$on('order-changed-event', () => {
        this.$cookies.refresh()
    })

    this.$root.$on('order-submitted', () => {
        this.$cookies.refresh()
    })

    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
       
    if(this.role >= 0) {
      this.getBlockOrdersStatus();
      this.getCustomerBlockedStatus();
      this.getIsCustomerInfoMissing();
    }
    
   
    //this.hideTopBarOnScroll();
    



  },
  methods: {
 

// hideTopBarOnScroll() {

//   if (this.$route.name != 'default') {
//     return;
//   }

//   var prevScrollpos = window.pageYOffset;
//   var element = document.getElementById("black-header-bar");
//   window.onscroll = function() {
//     var currentScrollPos = window.pageYOffset;
//     if (prevScrollpos > currentScrollPos) {
//       //element.classList.remove("d-none");
//       element.classList.add("d-lg-flex");
//     } else {
//       element.classList.remove("d-lg-flex");
//       //element.classList.add("d-none");
//     }
//     prevScrollpos = currentScrollPos;
//     if (currentScrollPos === 0) {
//       //element.classList.remove("d-none");
//       element.classList.add("d-lg-flex");
//     }
//   }
// },

    
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country) {
      this.lan = locale;
      this.text = country;
      i18n.locale = locale;
    },

    search() {
      this.$router.push({ name: 'catalog', query: { filter: this.keyword } })
      this.displayMobileSearch=false;
    },


    toNotificationIcon(notificationType) {
      if (notificationType == null) {
        return;
      }
      switch (notificationType) {
        case 0: return "fas fa-dolly";
        case 1: return "fas fa-check-double";
        case 2: return "fas fa-truck-loading";
        case 3: return "fas fa-exclamation-triangle";
        case 4 : return "fas fa-file-invoice-dollar";
        default : return "fas fa-dolly";
      }
    },

    toNotificationColor(notificationType) {
      if (notificationType == null) {
        return;
      }
      switch (notificationType) {
        case 0: return "bg-danger";
        case 1: return "bg-info";
        case 2: return "bg-success";
        case 3: return "bg-secondary";
        case 4: return "bg-primary";
        default : return "bg-secondary";
      }
    },

    toPath(notificationType){
      if (notificationType == null) {
        return;
      }
      if(notificationType==0 || notificationType==1 || notificationType==2 || notificationType==3){
        return '/orders/order'
      }

      if(notificationType==4){
        return '/invoices/list'
      }
    },

    toQuery(notif){
      if (notif == null) {
        return;
      }
      if(notif.type==0 || notif.type==1 || notif.type==2 || notif.type==3){
        return notif.orderId
      }

      if(notif.type==4){
        return null
      }
    },

    connect() {
      if(!this.userFullName) {
        this.$router.push({ name: "login" });
      }
    },

    onDraftModalClose() {
      this.$root.$emit('order-cart-modal-closed', true)
    },

    getBlockOrdersStatus() {
      OrdersApi.getBlockOrdersStatus().then((result) => {
        if (result) {
          this.blockOrdersStatus = result;
        }
      });
    },

    getCustomerBlockedStatus() {
      OrdersApi.getCustomerBlockedStatus().then((result) => {
        if (result) {
          this.isCustomerBlocked = result;
        }
      });
    },

    getIsCustomerInfoMissing() {
      OrdersApi.getIsCustomerInfoMissing().then((result) => {
        if (result) {
          this.customerinfoStatus = result;
        }
      });
    },

    

  },

  watch :{

    '$route.query.filter': {
        handler: function(filter) {
          this.keyword = filter;
        },
        deep: true,
        immediate: true
    },

    role: function() {
  
    },


    

    
  }

  


};
</script>

<style lang="scss" scoped>
.dropdown-border{
  border-bottom:3px solid $primary;
   border-radius:0px;
}
.menu li.active a,
.menu li a:hover {
  color: $primary !important;
}

.menu li.active,
.menu li:hover {
  border-bottom: 3px solid $primary;
}
</style>

<style>
  /* .navbar-header .dropdown.show .header-item {
    background-color: #5cb45b;
} */

    .navbar-header .mobile-user-button .dropdown .dropdown-menu {
        left: 10px !important;
        right: 10px !important;
        min-width:300px;
    }

    @media all and (max-width: 1024px) and (min-width: 1024px) {
    #logo {
        padding-left: 20px;
    } 

    }


  
    .menu {
      overflow-x: scroll;
      overflow-y: hidden; /* hide vertical scrollbar */
      white-space: nowrap;
      width: 100%;
      height: 100%; /* set height to fill the parent container */
      -ms-overflow-style: none; /* hide scrollbar on Edge */
      scrollbar-width: none; /* hide scrollbar on Firefox */
      -webkit-overflow-scrolling: touch; /* enable smooth scrolling on iOS */
    }

    .menu::-webkit-scrollbar {
      display: none; /* hide scrollbar on Chrome and Safari */
    }

    .menu:active {
      cursor: grab;
      cursor: -webkit-grab;
    }

    .menu:active::-webkit-scrollbar-thumb {
      background-color: #ddd;
    }

    .menu:active::-webkit-scrollbar-track {
      background-color: #f1f1f1;
    }

    .menu ul {
      display: flex; /* use flexbox to make menu items expand to fill available space */
      align-items: stretch; /* stretch menu items to the full height of the menu */
    }

    .menu li {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  /*border-bottom: 3px solid white;*/
  /*border-top: 3px solid white;*/
  cursor: pointer;
  position: relative;
}


.menu li a {
  display: flex; /* enable flexbox layout */
  align-items: center; /* center link content vertically */
  justify-content: center; /* center link content horizontally */
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-decoration: none;

  color: #333;
  text-decoration: none;
      font-size: 16px;
      font-weight: bold;
}

menu ul {
      display: inline-block;
      list-style-type: none;
      margin: 0;
      padding: 0;
    }

  

    


    /* #black-header-bar {
  background-color: #333;
  position: fixed;
  top: 0;
  width: 100%;
  display: block;
  transition: top 0.3s;
} */

</style>

<template>  
<div class="navbar-header"  >
 
  <!-- style="border-bottom: 1px solid #f4f4f4;" -->
  <header id="page-topbar"  >

    <!-- MOBILE SEARCH BOX -->
    <div v-if="displayMobileSearch"  
         class="row" style="height:65px;">
        <div class="col-2 text-right my-auto p-2">
            
            <div @click="displayMobileSearch=false" style="cursor: pointer;">
              <svg  enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24">
                <path d="M21,11v1H5.64l6.72,6.72l-0.71,0.71L3.72,11.5l7.92-7.92l0.71,0.71L5.64,11H21z"></path>
              </svg>
            </div>
        </div>

        <div class="col-8 text-center my-auto p-2">

        <b-form v-on:submit.prevent="" class="app-search d-sm-block w-100 p-0 m-0" >
         <!-- <div class="position-relative"> -->

              <b-input type="text" class="form-control text-dark font-size-16 font-weight-normal bg-white" 
                                style="font-weight:bold; border: 1px solid /*#d8dadf*/ #fff !important; height:33px;  background-color:#f2f2f2;padding:5px !important;" 
                                v-model="keyword" 
                                placeholder="Chercher un article ..." 
                                @keyup.native.enter="search()"/>

           
         <!-- </div> -->
         
       </b-form>

       
      </div>

      <div class="col-2 text-left my-auto p-2">
        <span 
            @click="search()" 
            class="bx bx-search-alt  text-primary" style="margin:auto;left: 8px; top: -1px;cursor: pointer; font-size:28px;"></span>
        </div>


    </div>

    <!-- BLOCK ORDERS HEADER BAR -->
    <!-- :class="this.$route.name === 'default' ? 'd-none d-lg-none' : 'd-none d-lg-flex'" -->
    <div v-if="!displayMobileSearch  && blockOrdersStatus && blockOrdersStatus.isBlock" id="black-header-bar"
     class="row bg-danger text-center   pr-4 pl-4 pt-1 pb-1" style="background-color: #d90100!important;">
      <div class="col-12 d-none d-md-flex text-white text-center justify-content-center align-items-center text-uppercase">
        <span class="font-size-14 font-weight-bold pr-2 pl-2 d-lg-inline d-md-inline d-sm-inline d-none" style="letter-spacing: 2px;" >{{ blockOrdersStatus.message }}</span>
      </div>
    </div>

    
    <div class="d-md-inline d-none" v-if="isHeaderBarEnable">
      <div class="bg-primary" style="color: #fff;">

      <div class="row home-page-80-width">
        <div class="col-6 text-left">
          <span class="font-size-14 pr-2 pl-2 d-lg-inline d-md-inline d-sm-inline d-none" ><img src="@/assets/images/marker-w.svg" height="20"  />{{vueAppCustomerInfo.address}}</span>
          <span class="font-size-14 pr-2 d-lg-inline d-md-inline d-sm-inline d-none"><img src="@/assets/images/mail-w.svg" height="20" class="mr-2" />{{vueAppCustomerInfo.email}}</span> 
        </div>

      <div class="col-6 text-right" >
          <span class="font-size-14 pr-2 pl-2 d-lg-inline d-md-inline d-sm-inline d-none" ><img src="@/assets/images/phone-w.svg" height="20" class="mr-2" />{{vueAppCustomerInfo.phone}}</span>
        </div>
      </div>

      </div>
    </div>


    <!-- CUSTOMER BLOCKED -->
    <div v-if="!displayMobileSearch && userFullName && isCustomerBlocked && isCustomerBlocked === true" id="black-header-bar"
     class="row bg-danger text-center   pr-4 pl-4 pt-1 pb-1 pb-md-1 pb-0" style="background-color: #d90100!important;">
      <div class="col-12 d-none d-lg-flex text-white text-center justify-content-center align-items-center text-uppercase">
        <span class="font-size-14 font-weight-bold pr-2 pl-2 d-lg-inline d-md-inline d-sm-inline d-none" style="letter-spacing: 2px;" >Vous ne pouvez pas passer de commande, merci de contacter le service financier</span>
      </div>
    </div>

    <!-- ANNONCES -->
    <div v-if="userFullName" 
     class="row d-none d-sm-inline text-center" style="background-color: #d90100 !important;" >
      <div class="col-12 text-white font-weight-bold text-center justify-content-center align-items-center ">
        <slidingComponents/>
      </div>
    </div>

     <!-- CUSTOMER MISSING INFO -->
       <a href="/profil">
        <div v-if="showCustomerInfo && !displayMobileSearch && userFullName && customerinfoStatus && customerinfoStatus.infoCustomerIsMissing && customerinfoStatus.infoCustomerIsMissing == true" id="black-header-bar"
        class="row bg-danger text-center   pr-4 pl-4 pt-md-1 pt-0 pb-md-1 pb-0" style="background-color:#FFF8E5 !important;">
          <div class="col-12 d-none d-lg-flex text-dark text-center justify-content-center align-items-center">
            <span class="font-size-14 pr-2 pl-2 d-lg-inline d-md-inline d-sm-inline d-none" style="letter-spacing: 2px;" >Afin de compléter votre profil, veuillez <u  style="color:#D97706 !important;font-weight:900">cliquer ici</u> pour renseigner votre adresse mail de facturation (nécessaire pour la <u style="color:#D97706 !important; font-weight:900">facturation électronique</u>)</span>
          </div>
        </div>
      </a>



    <!-- LOGO BLOCK & MOBILE MENU BUTTON & SEARCH INPUT (desktop search) -->
    <div v-if="!displayMobileSearch" class="navbar-header" style="box-shadow: 0 2px 6px 0 rgba(0,0,0,.12), inset 0 -1px 0 0 #dadce0;"  >


      <div class="row w-100 m-sm-4 m-0" >

        <div class="col-1 col-md-1 col-lg-2" style="z-index:9999999">
            <div class="d-flex mobile-user-button">
              
              <!-- MOBILE USER BUTTON -->
              <b-dropdown right variant="black" toggle-class="header-item" class="d-none d-md-none" style="height:65px !important; " >
                  <template v-slot:button-content>
                      <button
                            type="button"
                            class="btn btn-sm p-0 m-0  "
                            >
                            <i class="fa fa-fw fa-bars text-primary" style=" font-size: 20px;"></i>
                      </button>            
                  </template>

                      <!-- MOBILE MENU -->
                      <a v-if="!userFullName" href="/login" class="dropdown-item" >
                              <h5 class="text-primary font-weight-bold"><i class="bx bx-user font-weight-bold align-middle mr-1 "></i>Connexion</h5>
                              <span class="text-secondary ">
                                Se connecter à votre espace client Pro
                                </span>
                        </a>
          
                        <a v-if="userFullName" href="/" class="dropdown-item text-dark" >
                              <i class="bx bx-home-alt mr-2  font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Accueil
                        </a>

                        <a v-if="userFullName" href="/catalogue" class="dropdown-item text-dark" >
                              <i class="bx bx-cart-alt  font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Catalogue des articles
                        </a>


                        <b-dropdown-divider v-if="userFullName"></b-dropdown-divider>

                        <a v-if="userFullName" href="/commandes" class="dropdown-item text-dark" >
                              <i class="bx bx-file   font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Documents
                        </a>

                        <a v-if="userFullName && isSupplier" href="/reporting" class="dropdown-item text-dark" >
                              <i class="bx bx-bar-chart-alt  font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Reporting
                        </a>

                        <a v-if="userFullName && isSupplier && isPartner && isReportingSupplierEnable" href="/reporting-partner" class="dropdown-item text-dark" >
                              <i class="bx bx-bar-chart-alt  font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Reporting
                        </a>

                        <b-dropdown-divider v-if="userFullName"></b-dropdown-divider>

                        <a v-if="userFullName && isSupplier" href="/utilisateurs" class="dropdown-item text-dark" >
                              <i class="bx bx-user-plus   font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Utilisateurs
                        </a>

                        <a v-if="userFullName && isSupplier" href="/bannieres" class="dropdown-item text-dark" >
                              <i class="fab fa-adversal   font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Bannières
                        </a>

                        <!-- <a v-if="userFullName && isSupplier" href="/articles" class="dropdown-item text-dark" >
                              <i class="bx bx-list-ul   font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Articles
                        </a> -->

                        <a v-if="userFullName" href="/profil" class="dropdown-item text-dark" >
                            <i class="bx bx-user font-size-16 align-middle mr-1 font-weight-bold"></i>
                            profil de {{this.userFullName}}
                      </a>

                        <b-dropdown-divider v-if="userFullName"></b-dropdown-divider>

                        <a v-if="userFullName" href="/logout" class="dropdown-item text-danger font-weight-bold" >
                            <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger font-weight-bold"></i>
                            Se déconnecter
                        </a>
                      <!-- END MOBILE MENU -->

              </b-dropdown>
              <!-- END USER BUTTON -->

              <!-- MAIN LOGO -->
              <div class="my-auto" >
                <router-link to="/" class="logo logo-light  " id="logo" >
                  <span class="logo-sm">
                    <img class="ml-2" :src="customerAsstesDiractory + 'logo.png'" alt :height="mobileLogoHeight ? mobileLogoHeight : 23" />
                  </span>
                  <span class="logo-lg">
                    <img class="ml-2" :src="customerAsstesDiractory + 'logo.png'" alt :height="logoHeight ? logoHeight : 60" />
                  </span>
                </router-link>
              </div>
            </div>
            
        </div>

        <div class="col-0 col-md-9 col-lg-8 d-none d-md-block my-auto" style="margin-top: 0px !important;margin-bottom: 0px !important;">

              <div class="my-auto" style="height:100%;" >
                <!-- SEARCH INPUT (FOR DESKTOP) -->
                <!-- <b-form v-on:submit.prevent="" class="app-search d-none d-sm-block p-0 " >
                  <div class="position-relative">

                    
                    <b-input type="text" class="form-control text-dark font-size-16 font-weight-normal" 
                                    style="font-weight:bold; " 
                                    v-model="keyword" 
                                    placeholder="Chercher un produit par désignation ou référence" 
                                    @keyup.native.enter="search()"/>

                    <span class="bx bx-search-alt text-danger" style="margin:auto;"></span>
                  </div>
                </b-form> -->
                  
                  
                <!-- END LOGO BLOCK & MOBILE MENU BUTTON & SEARCH INPUT (desktop search) -->
              
                <div class="menu">
                <ul style="margin:0px;height:100%;"> 
                    <template v-for="(item, index) of menuItems" > 
                      
                      <li :class="$route.name != 'default' && $route.path == item.link ?  'active' : ''" :key="index"  
                        v-if=" role == null ? item.role==0 && (item.id !== 103 || !hideUsersMenu)  : 
                          isPartner== true ?  (item.role==role && item.isPartner === isPartner  ) :
                          (item.role==role &&  !item.onlyPartner && 
                          ( permission && permission.some(pr=> item.subRole!=null ? item.subRole.includes(pr) :true )  || item.subRole==null ) && 
                          (item.id !== 11 || isClaimShowInTopBar)       && 
                          (item.id !== 103 || !hideUsersMenu) 
                           && (item.id !== 105 || !isAgencySupplier) 
                          )  " >
                          
                          <router-link
                            class="text-dark" 
                            :to="item.link"
                            role="button"
                            @click="onMenuClick($event)" 
                            >
                            <!--i :class="`${item.icon} mr-2 `"></i--> {{ customCatalogLabel && (item.id === 2 || item.id === 101 ) ? customCatalogLabel : $t(item.label) }} 
                          </router-link>
                        </li>
                    </template>
                  </ul> 
                </div>




                

              </div>

        </div>

        <div class="col-11 col-md-2 col-lg-2 text-right">
              <!-- NOTIFICATIONS BUTTON + CART + LEFT USER BUTTON + MOBILE SEARCH ICON -->
              <div class="">

                  <!-- SEARCH BUTTON -->
                  <div v-if="showShearchButtonOnTopBar" class="dropdown b-dropdown btn-group d-md-none">

                    <button
                      type="button"
                      class="btn header-item noti-icon"
                       @click="displayMobileSearch=true">

                    <i class="bx bx-search-alt text-dark " style="font-size:28px;"></i>
                    </button>
                  </div>
                  <!-- END SEARCH BUTTON -->

                  <!-- HELP BUTTON -->
                  <b-dropdown right variant="black" 
                      v-if="role ==0 && !isClaimShowInTopBar" toggle-class="header-item noti-icon" 
                      class=" d-lg-inline-block d-none"  >

                    <template v-slot:button-content>
                      <i class="bx bx-help-circle text-dark" style="font-size:28px;"></i>
                    </template>

                        <a v-if=" this.envSupplierName == 'cab'  " href="/e-Cabdephar-Guide-Utilisateur.pdf" class="dropdown-item" target="_blank">
                              <h5 class="text-primary font-weight-bold">Besoin d'aide ?</h5>
                                <span class="text-secondary">
                                  <u>Télécharger</u> le guide d'utilisation
                                </span>
                        </a>

                        <a href="/claim?blNumber=" class="dropdown-item" >
                              <h5 class="text-primary font-weight-bold">Réclamations & Suggestions ?</h5>                             
                        </a> 
                  </b-dropdown>
                  <!-- END HELP BUTTON -->

                  <!-- NOTIFICATIONS BUTTON -->
                  <b-dropdown  v-if="userFullName"
                    right
                    menu-class="dropdown-menu-lg p-0"
                    toggle-class="header-item noti-icon"
                    variant="black"
                  >
                    <template v-slot:button-content>
                      <i class="bx bx-bell text-dark" style="font-size:28px;"></i>
                      <span
                        class="badge badge-danger badge-pill" :class="notificationsCount == 0 ? 'd-none' : ''"
                      >{{notificationsCount}}</span>
                      
                    </template>

                    <div class="p-3">
                      <div class="row align-items-center">
                        <div class="col">
                          <h6 class="m-0 font-weight-bold">Notifications</h6>
                        </div>
                        <div class="col-auto">
                          
                        </div>
                      </div>
                    </div>
                    <simplebar style="max-height: 230px;">

                      <!-- <h6 v-if="notif.type == 5" class="mt-0 mb-1">
                        <div>
                          Commande modifiée {{ notif.extraFieldsNumBc }} du {{ notif.extraFieldsDateBc }},
                        </div>
                        <div>
                          {{ notif.extraFieldsLibArt }} ({{ notif.extraFieldsCodArt }}),
                        </div>
                        <div>
                          Cmd : {{ notif.extraFieldsQteCmd }} |
                          Préparé : {{ notif.extraFieldsQtePrep }}
                        </div>
                      </h6> -->
                      
                      <div v-for="notif in filtredNotifications" :key="notif.id">
                        <router-link :to="{ path:toPath(notif.type), query: { orderId:  toQuery(notif) }}">
                          <a href="javascript: void(0);" class="text-reset notification-item">
                            <div class="media">
                              <div class="avatar-xs mr-3">
                                <span class="avatar-title rounded-circle font-size-16" :class="toNotificationColor(notif.type)">
                                  <i :class="toNotificationIcon(notif.type)"></i>
                                </span>
                              </div>
                              <div class="media-body">

                                <h6 class="mt-0 mb-1">{{notif.message}}</h6>
                                <div class="font-size-12 text-muted">
                                  
                                  <p class="mb-0">
                                    <i class="mdi mdi-clock-outline"></i>
                                    {{ notif.date }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </a>
                        </router-link>

                      </div>
                    </simplebar>
                    <div class="p-2 border-top">
                      <div class="row">

                      <div class="col-2">
                          <a class="btn btn-sm btn-light btn-block text-center" :class="notifPage <= 1 ? 'd-none' : ''" @click="notifPage--; getNotifications();"  href="javascript:void(0)">
                              <i class="fas fa-backward text-left" ></i>    
                          </a>

                        </div>

                      <div class="col-8 text-center pt-1">
                        <span class="mr-2 ml-2 text-muted font-weight-bold" :class="notifPage == 1 ? 'd-none': ''">Page {{notifPage}}</span>
                      </div>

                        <div class="col-2">
                          <a class="btn btn-sm btn-light btn-block text-center" :class="notifPage >= notifPagesNbr ? 'disabled' : ''" href="javascript:void(0)" @click="notifPage++; getNotifications();">
                            <i class="fas fa-forward text-right" ></i>
                              
                          </a>

                        </div>
                        
                      </div>

                    </div>
                  </b-dropdown>
                  <!-- END NOTIFICATIONS BUTTON -->


                  <!-- CART BUTTON -->
                  <!-- <div class="dropdown b-dropdown btn-group">
                    <button
                      type="button"
                      class="btn header-item noti-icon right-bar-toggle toggle-right"
                      @click="showDraftOrder = true"
                    >
                    
                    <i class="bx bx-cart-alt text-dark toggle-right" style="font-size:28px;"></i>
                      <span class="badge badge-danger badge-pill" :class="this.draftOrderLinesCount == 0 ? 'd-none' : ''">{{this.draftOrderLinesCount}}</span>
                    </button>
                  </div> -->
                  <!-- END CART BUTTON -->

                 

                  
                  <!-- LEFT USER BUTTON -->
                  <!-- style="border-bottom:4px solid #00acc8; border-radius:0px;" -->
                  <b-dropdown right variant="black" toggle-class="header-item noti-icon" class=" d-md-inline-block  dropdown-border  "   >
                    <template v-slot:button-content>


                      <!-- <div class="row d-none d-sm-flex" @click=" connect()"  > -->
                        <!-- border: 2px solid #00acc8 -->
                        <!-- d-none d-sm-flex -->
                      <div class="row  "  >

                          <!-- <div class="col-xl-5 col-lg-12">
                            <img
                            :title="userFullName" 
                                class="rounded-circle header-profile-user"
                                src="@/assets/images/users/avatar-1.jpg"
                              
                              />


                          </div> -->
         
                         
                          <!-- <div class="col-xl-12 col-lg-12 d-none d-lg-inline-block text-left topbar-hide-user-name" >
                            <span class="d-none d-xl-inline-block p-2" :class="userFullName && userShortName ? 'text-dark' : 'text-dark'" :title="userFullName" style="font-size:16px;font-weight:bold;"> <i class=" fas fa-user text-dark pr-2" style="font-size:16px;"/> {{userFullName && userShortName ? userShortName : 'Accès Clients'}}</span>
                            <i class="mdi mdi-chevron-down d-none d-xl-inline-block text-dark   pr-2" style="font-size:15px;"></i>
                          </div> -->

                          <div class="col-xl-12 col-lg-12  text-left" >
                            <span class=" p-2" :class="userFullName && userShortName ? 'text-dark' : 'text-dark'" :title="userFullName" style="font-size:16px;font-weight:bold;"> 
                              <i class=" fas fa-user text-dark pr-2" style="font-size:16px;"/> <span class="d-xl-inline-block d-none">{{userFullName && userShortName ? userShortName : customerPortalName}}</span></span>
                            <i class="mdi mdi-chevron-down text-dark  d-xl-inline-block d-none pr-2" style="font-size:15px;"></i>
                          </div>

                      </div>

                        <!-- <button
                              type="button"
                              class="btn btn-sm p-0 m-0  d-sm-none"
                              >
                              <i class="bx bx-user text-dark" style=" font-size: 28px;"></i>
                        </button> -->
                                
                    </template>

                        <a v-if="!userFullName" href="/login" class="dropdown-item" >
                              <h5 class="text-primary font-weight-bold"><i class="bx bx-user font-weight-bold align-middle mr-1 "></i>Connexion</h5>
                              <span class="text-secondary ">
                                Se connecter à votre espace client Pro
                                </span>
                        </a>
          
                        <a v-if="userFullName" href="/" class="dropdown-item text-dark" >
                              <i class="bx bx-home-alt  font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Accueil
                        </a>

                        <a v-if="userFullName 
                        && ((isSupplier &&  (permission.includes('SUPPLIER_ADMIN') || permission.includes('SUPPLIER_ADD_ORDER'))) 
                        || permission.includes('CUSTOMER_ADMIN')|| permission.includes('ADD_ORDER'))" href="/catalogue" class="dropdown-item text-dark" >
                              <i class="bx bx-cart-alt font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Catalogue des articles
                        </a>

                        
                        <b-dropdown-divider v-if="userFullName && ((isSupplier &&  permission.includes('SUPPLIER_ADMIN')) || permission.includes('CUSTOMER_ADMIN')|| permission.includes('ORDER_LIST'))"></b-dropdown-divider>


                        <a v-if="userFullName  && ((isSupplier && (permission.includes('SUPPLIER_ADMIN') || permission.includes('SUPPLIER_DOCUMENT_ACCESS'))) || permission.includes('CUSTOMER_ADMIN')|| permission.includes('ORDER_LIST'))" href="/commandes" class="dropdown-item text-dark" >
                              <i class="bx bx-file    font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Documents
                        </a>

                        <a v-if="userFullName && ((isSupplier &&  permission.includes('SUPPLIER_ADMIN')) || permission.includes('CUSTOMER_ADMIN')|| permission.includes('REPORTING')) && isPartner== false" href="/reporting" class="dropdown-item text-dark" >
                              <i class="bx bx-bar-chart-alt  font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Reporting
                        </a>

                        <a v-if="userFullName 
                          && (role ==0 || (isSupplier && ( permission.includes('SUPPLIER_ADMIN') || permission.includes('SUPPLIER_ADD_CLAIM') || permission.includes('SUPPLIER_CLAIM_LIST')  || permission.includes('SUPPLIER_CLAIM_SERVICE_MANAGER')  ))) 
                          && isPartner== false" href="/claim" class="dropdown-item text-dark" >
                              <i class="bx bx-chat  font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Réclamations
                        </a>

                        <a v-if="userFullName && isSupplier && isPartner === true && isReportingSupplierEnable" href="/reporting-partner" class="dropdown-item text-dark" >
                              <i class="bx bx-bar-chart-alt  font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Reporting
                        </a>

                        <b-dropdown-divider v-if="userFullName"></b-dropdown-divider>
                      <a v-if="!hideUsersMenu && userFullName && ((isSupplier &&  permission.includes('SUPPLIER_ADMIN')) || permission.includes('CUSTOMER_ADMIN')) && isPartner== false" :href="permission.includes('CUSTOMER_ADMIN')   ? 'customer-utilisateurs' :'/utilisateurs' " class="dropdown-item text-dark" >
                              <i class="bx bx-user-plus   font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Utilisateurs
                        </a>

                        <a v-if="!isAgencySupplier && userFullName && (isSupplier &&  permission.includes('SUPPLIER_ADMIN')) && isPartner== false " href="/bannieres" class="dropdown-item text-dark" >
                              <i class="fab fa-adversal   font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Configuration 
                        </a>

                        <!-- <a v-if="userFullName && isSupplier" href="/articles" class="dropdown-item text-dark" >
                              <i class="bx bx-list-ul   font-size-16 align-middle mr-1 font-weight-bold"></i>
                              Articles
                        </a> -->


                        <a v-if="userFullName" href="/profil" class="dropdown-item text-dark" >
                            <i class="bx bx-user font-size-16 align-middle mr-1 font-weight-bold"></i>
                            profil de {{this.userFullName}}
                      </a>

                        <b-dropdown-divider v-if="userFullName"></b-dropdown-divider>

                        <a v-if="userFullName" href="/logout" class="dropdown-item text-danger font-weight-bold" >
                            <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger font-weight-bold"></i>
                            Se déconnecter
                        </a>

                  </b-dropdown>
                  <!-- END USER BUTTON -->

              </div>
              <!-- END NOTIFICATIONS BUTTON + CART + LEFT USER BUTTON + MOBILE SEARCH ICON -->
        </div>


      </div>

    </div>

  </header>










  <!-- <HorizontalNav /> -->

  <!-- Cart (draft) Modal -->
  <b-modal
      
      v-model="showDraftOrder"
      title="Envoyer la commande"
      centered 
      title-class="text-primary d-print-none"
      title-tag="h5"
      header-close-variant="danger"
      header-class="d-print-none"
      class="modal-fullscreen"
      size="xl"
      full-screen
      no-close-on-esc
      hide-footer
      hide-header

      @hide="onDraftModalClose()"

      >

      <div class="" @click="showDraftOrder=false" style="cursor:pointer;">
        <svg  enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24">
          <path d="M21,11v1H5.64l6.72,6.72l-0.71,0.71L3.72,11.5l7.92-7.92l0.71,0.71L5.64,11H21z"></path>
        </svg>
      </div>

      <OrderModal v-if="draftOrderId" :orderId="draftOrderId"  v-on:update="showDraftOrder=false;" />

      <!-- Empty Cart -->
      <div class="row text-center" v-if="!draftOrderId">
        
        <div class="col-12 d-print-none" >
          <img :src="require('@/assets/images/logo.png')" height="40" alt="logo" />
        </div>
        
        <div class="col-12 mt-4">
          <h5 class="text-center text-danger font-weight-bold" >Le Panier est vide !</h5>
          <h5 class="text-center text-dark" v-if="!draftOrderId"><i>Veuillez ajouter au moins un article à votre commande !</i></h5>
        </div>
      </div>
     
    </b-modal>

</div>

</template>
